<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/cart_sub.jpg" />
      <h1 class="">ご注文</h1>
    </div>
    <h2 class="mb-0 mt-2 text-left">2.お届け先の選択</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">1.カートを確認</li>
        <li class="here px-3">2.お届け先の選択</li>
        <li class="px-3">3.お支払い方法の選択</li>
        <li class="px-3">4.最終確認</li>
      </ul>
    </div>
    <div class="detail-cart box-p-20 border">
      <h2 class="mb-3 text-left">別送先住所を追加</h2>
      <div class="form-member my-5">
        <div class="inner">
          <dl>
            <dt>お名前<span class="rqr">必須</span></dt>
            <dd>
              <input
                v-model="addressName"
                type="text"
                maxlength="100"
                class="my-2"
                style="width: 65%"
                ref="addressName"
              />
              <select v-model="appendWord" class="px-3" ref="appendWord">
                <option value="1"></option>
                <option value="様方">様方</option>
                <option value="気付">気付</option>
              </select>
            </dd>
            <dt>住所<span class="rqr">必須</span></dt>
            <dd>
              〒
              <input
                v-model="zipCode"
                type="text"
                maxlength="7"
                class="mt-2"
                style="width: 100px"
                ref="zipCode"
              />
              <input
                @click="zipSearch"
                type="button"
                value="自動住所入力をする"
                class="btn ml-3 mt-2"
              /><br />
              <span>例）1001234</span>
              <input
                v-model="address1"
                type="text"
                maxlength="100"
                class="mt-3"
                style="width: 100%"
                ref="address1"
              /><br />
              <span>例）千葉県浦安市千鳥15－8</span>
              <input
                v-model="address2"
                type="text"
                maxlength="100"
                class="mt-3"
                style="width: 100%"
                ref="address2"
              /><br />
              <span>例）マナビスマンション101</span>
            </dd>
            <dt>電話<span class="rqr">必須</span></dt>
            <dd>
              <input
                v-model="tel"
                type="text"
                maxlength="15"
                style="width: 50%"
                ref="tel"
              /><br />
              <span>例）03-0000-0000</span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="text-center">
        <router-link to="/cart/delivery" class="btn d-inline-block"
          >追加しないで戻る</router-link
        >
      </div>
    </div>
    <div class="text-center box-p-20">
      <button class="btn d-inline-block" @click="addAddress">
        別送先住所を追加する
      </button>
    </div>
  </section>
</template>

<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";
let request = new Request();

export default {
  data() {
    return {
      addressName: "",
      appendWord: "1",
      zipCode: "",
      address1: "",
      address2: "",
      tel: "",
    };
  },
  mounted() {
    window.scroll(0, 0);
  },
  methods: {
    addAddress() {

      let require = (name, label) => {
        if (this[name] === "") {
          Message.error().fire({
            title: label + "が未入力です",
            onAfterClose: () => {
              this.$refs[name].focus();
            }
          });
          return false;
        }
        return true;
      };

      if (!require("addressName", "お名前")) return;
      if (!require("appendWord", "気付等")) return;
      if (!require("zipCode", "郵便番号")) return;
      if (!require("address1", "住所番地")) return;
      if (!require("tel", "電話番号")) return;

      let postParams = [
        this.addressName,
        this.appendWord,
        this.zipCode,
        this.address1,
        this.address2,
        this.tel,
      ];
      let requestParams = request.createParams(
        "webMdlShippingAddress",
        "addAddress",
        postParams
      );
      let messages = [
        "　お名前：" + this.addressName,
        "　気付等：" + this.appendWord,
        "郵便番号：" + this.zipCode,
        "住所番地：" + this.address1,
        "建物名等：" + this.address2,
        "電話番号：" + this.tel,
      ];
      Message.confirm()
        .fire({
          title: "下記内容で追加します。宜しいですか？",
          html: messages.join("<br>"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            request
              .create()
              .post("", requestParams)
              .then((data) => {
                let focusEl = null;
                if (data.status == "bad") {
                  Message.error()
                    .fire({
                      title: data.msg,
                      onAfterClose: () => {
                        if (focusEl) {
                          focusEl.focus();
                        }
                      },
                    })
                    .then(() => {
                      switch (data.arg) {
                        case "arg1":
                          focusEl = this.$refs.addressName;
                          break;
                        case "arg2":
                          focusEl = this.$refs.appendWord;
                          break;
                        case "arg3":
                          focusEl = this.$refs.zipCode;
                          break;
                        case "arg4":
                          focusEl = this.$refs.address1;
                          break;
                        case "arg5":
                          focusEl = this.$refs.address2;
                          break;
                        case "arg6":
                          focusEl = this.$refs.tel;
                          break;
                      }
                    });
                } else {
                  // 成功した場合
                  Message.success()
                    .fire({
                      position: "center",
                      showConfirmButton: true,
                      timer: null,
                      toast: false,
                      title: "登録が完了しました",
                    })
                    .then(() => {
                      this.$router.push("/cart/delivery");
                    });
                }
              });
          }
        });
    },
    zipSearch() {
      let postParams = [this.zipCode];
      let requestParams = request.createParams(
        "webMdlShippingAddress",
        "getAddressFromZip",
        postParams
      );

      request
        .create()
        .post("", requestParams)
        .then((data) => {
          let focusEl = null;
          if (data.status == "bad") {
            Message.error()
              .fire({
                title: data.msg,
                onAfterClose: () => {
                  if (focusEl) {
                    focusEl.focus();
                  }
                },
              })
              .then(() => {
                focusEl = this.$refs.zipCode;
              });
          } else {
            this.address1 = data.address;
          }
        });
    },
  },
};
</script>